import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1493.60188,1468.29412 L225.837176,1468.29412 C523.211294,387.898824 755.305412,1443.89882 983.898353,1115.91765 C1268.51012,707.635294 1574.46776,710.232941 1694.07247,1468.29412 L1493.60188,1468.29412 Z M677.601882,338.882353 C802.401882,338.882353 903.484235,440.077647 903.484235,564.764706 C903.484235,689.451765 802.401882,790.647059 677.601882,790.647059 C552.914824,790.647059 451.719529,689.451765 451.719529,564.764706 C451.719529,440.077647 552.914824,338.882353 677.601882,338.882353 L677.601882,338.882353 Z M-0.0451764706,1807.11765 L1919.95482,1807.11765 L1919.95482,113 L-0.0451764706,113 L-0.0451764706,1807.11765 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconImageSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconImageSolid, _Component);

  var _super = _createSuper(IconImageSolid);

  function IconImageSolid() {
    _classCallCheck(this, IconImageSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconImageSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconImage",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconImageSolid.displayName = "IconImageSolid";
  return IconImageSolid;
}(Component);

IconImageSolid.glyphName = 'image';
IconImageSolid.variant = 'Solid';
IconImageSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconImageSolid;
export { IconImageSolid };